export enum TypesEvents {
    ADD = 'add',
    EDIT = 'edit',
    ERROR = 'error',
    FINISH = 'finalizar',
    ERROR_IMAGES = 'error_images',
    DELETE = 'delete'
}
